/* eslint-disable react/jsx-props-no-spreading */
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import styled from 'styled-components';

const LinkCell = (onClick?: (item: unknown) => void) => (cellProps: GridCellProps) => (
	<td>
		<StyledLink onClick={() => onClick(cellProps.dataItem)}>{cellProps.dataItem[cellProps.field]}</StyledLink>
	</td>
);

export default LinkCell;

export const StyledLink = styled.a`
	cursor: pointer;

	&:hover {
		color: ${(props) => props.theme.brandingColourHeavy};
		text-decoration: underline !important;
	}
`;
